import React, { useEffect, useState } from "react";
import { Empty, Spin } from "antd";
import "./Softwares.css";

// A commercial-style product showcase, deliberately not the wiki-tree pattern BIM Framework/
// Learn use — one card per PROYAPI-built application (pages/softwares/<name>/), each with its
// demo video embedded directly via a native <video> element. preload="metadata" keeps the
// initial page load cheap regardless of how many products exist (only duration/dimensions are
// fetched up front) — the full 250-500MB file is only streamed once a visitor actually presses
// play, via the Range-request-aware /api/softwares/video/* route.
export default function Softwares() {
  const [softwares, setSoftwares] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/softwares/list")
      .then((r) => r.json())
      .then((d) => setSoftwares(d.softwares || []))
      .catch(() => setSoftwares([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="softwares-page">
      <div className="softwares-hero">
        <h1 className="softwares-hero-title">
          Custom <em>Softwares</em>
        </h1>
        <p className="softwares-hero-sub">
          In-house tools built by PROYAPI for infrastructure engineering workflows.
        </p>
      </div>

      {loading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 48 }}>
          <Spin size="large" />
        </div>
      ) : softwares.length === 0 ? (
        <Empty description="More tools coming soon" style={{ marginTop: 40 }} />
      ) : (
        <div className="softwares-grid">
          {softwares.map((s) => (
            <div key={s.key} className="software-card">
              {s.video && (
                <div className="software-media">
                  <video
                    controls
                    preload="metadata"
                    src={`/api/softwares/video/${encodeURIComponent(s.key)}?v=${s.video.version}`}
                  />
                </div>
              )}
              <div className="software-body">
                <div className="software-name">{s.name}</div>
                {s.description && <p className="software-desc">{s.description}</p>}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
